import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";

export const Saveusersdetails = async (data) => {
  if (!data?.uid) {
    console.error("Missing UID for user details save");
    return { success: false, error: "UID is required" };
  }

  const docRef = doc(db, "users_details", data.uid);
  const savequery = {
    ...data, 
    guid: Cookies.get("guid") || null,
    ip: Cookies.get("ipaddres") || null,
    update_date_time: new Date(),
    date_time: new Date(),
    device: navigator.userAgent || "unknown",
    status: true,   
  };

  try {
    await setDoc(docRef, savequery);
    return { success: true };
  } catch (err) {
    console.error("Error saving user details:", err);
    return { success: false, error: err.message };
  }
};
